// extracted by mini-css-extract-plugin
export default {"centerText":"FonKQZDdA2fl2J3lS5tm","wrapper":"kgkvGg06Ip601pw4eoix"};